<template>
    <dl :class="['chart-legend', legendClass]" v-if="type === 'donut' || type === 'bar-horizontal-stacked'">
        <div class="chart-legend--item-description">
            <div class="chart-legend--item-description-wrapper" v-for="(item, index) in schoolLegend" :key="index">
                <dd class="chart-legend--item-description-color" :style="{ backgroundColor: item.legendColor }"/>
                <dd class="chart-legend--item-description-text u-reset">
                    {{ item.legendText }}
                </dd>
            </div>
        </div>
    </dl>
    <dl :class="['chart-legend', legendClass]" v-else-if="type === 'bar-vertical'">
        <div class="chart-legend--item" v-for="(item, index) in schoolLegend" :key="index">
            <dt class="chart-legend--text u-reset">
                {{ item.name }}
            </dt>
            <dd class="chart-legend--text u-reset">
                {{ item.value }}
            </dd>
        </div>
    </dl>
    <div :class="['chart-legend', legendClass]" v-else-if="type === 'bar-vertical-stacked'">
        <div class="chart-legend--item-description">
            <div class="chart-legend--item-description-wrapper" v-for="(item, index) in slicedSchoolLegendDescriptions" :key="index">
                <dt class="chart-legend--item-description-color" :style="{ backgroundColor: item.legendColor }"/>
                <dd class="chart-legend--item-description-text u-reset">
                    {{ item.legendText }}
                </dd>
            </div>
        </div>
        <div class="chart-legend--item" v-for="(item, index) in slicedSchoolLegendItems" :key="index">
            <dt class="chart-legend--text u-reset">
                {{ item.name }}
            </dt>
            <dd class="chart-legend--text u-reset">
                {{ item.value }}
            </dd>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            type: {
                type: String,
                default: '',
            },
            schoolLegend: {
                type: Array,
                default: () => [],
            },
        },
        computed: {
            legendClass() {
                if (this.type === 'bar-vertical-stacked') {
                    return 'chart-legend--bar-vertical-stacked';
                } else if (this.type === 'bar-vertical') {
                    return 'chart-legend--bar-vertical';
                } else if (this.type === 'bar-horizontal-stacked') {
                    return 'chart-legend--bar-horizontal-stacked';
                } else if (this.type === 'donut') {
                    return 'chart-legend--donut';
                }
                return '';
            },
            slicedSchoolLegendDescriptions() {
                return this.schoolLegend.slice(0, 2);
            },
            slicedSchoolLegendItems() {
                return this.schoolLegend.slice(2);
            },
        },
    };
</script>
